import { ButtonBase as MuiButtonBase, styled, darken } from '@mui/material'

const ButtonBase = styled(MuiButtonBase, {
  shouldForwardProp: (prop) => prop !== 'active'
})(({ theme, active = false }) => ({
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5, 2),
  backgroundColor: active ? darken(theme.custom.keysys.blue, 0.5) : darken(theme.custom.keysys.blue, 0.6),
  color: active ? darken(theme.palette.background.paper, 0.2) : theme.palette.background.paper,
  boxShadow: active ? theme.shadows[8] : theme.shadows[4],
  transition: 'all 0.3s ease-in-out',
  textAlign: 'left',
  width: '100%',
  '&:hover': {
    backgroundColor: active ? darken(theme.custom.keysys.blue, 0.3) : darken(theme.custom.keysys.blue, 0.4)
  }
}))

export { ButtonBase }
